import { Box, Typography } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTrashablePromises from "hooks/useTrashablePromises";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import {
  OrganizationUserDetails,
  SaveResponse,
  SaveUserRequest,
} from "services/KnowfullyAdminClient";
import translateError from "utils/translateError";
import UserForm from "./UserForm";

const UserCreateForm = () => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { usersListUrl, userDetailsUrl, userService } = useGlobalContext();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const onSubmit = async (values: OrganizationUserDetails) => {
    const newUser = new SaveUserRequest({
      organizationId: values.organizationId,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      timeZone: values.timeZone,
      externalSourceId: values.externalSourceId,
      roleNames: values.roles,
    });
    try {
      const response: SaveResponse = await registerPromise(
        userService.saveUser(newUser)
      );
      queryClient.invalidateQueries("searchOrganizationUsers");
      navigate(userDetailsUrl(response?.id));
    } catch (err: any) {
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={usersListUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <Typography variant="h5">
        <T id="newUser" />
      </Typography>
      <UserForm
        onSubmit={onSubmit}
        submitLabel={t({ id: "userFormCreateButton" })}
        onCancel={() => navigate(usersListUrl())}
      />
    </>
  );
};

export default UserCreateForm;
